export var BillStatus;
(function (BillStatus) {
    BillStatus["Paid"] = "Paid";
    BillStatus["Pending"] = "Pending";
    BillStatus["OrderGenerated"] = "OrderGenerated";
})(BillStatus || (BillStatus = {}));
